<template>
  <v-app>
    <!-- <simplert :useRadius="true" :useIcon="true"></simplert> -->
    <guest-dialog :showDialog="showDialog" @closeDialog="showDialog = false"></guest-dialog>

    <v-navigation-drawer
      app
      fixed
      clipped
      temporary
      v-model="sideNav">
      <v-list>
        <v-list-tile>
          <v-list-tile-action color="primary">
            <router-link to="/" tag="span" style="cursor: pointer">{{ $t("app_title") }}</router-link>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile v-if="userIsAuthenticated" @click.stop="showDialog = true">
          <v-list-tile-action>
            <v-icon>person_add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ $t("add_guest") }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ item.title }}</v-list-tile-content>
        </v-list-tile>

        <v-list-group>
          <v-list-tile slot="item">
            <v-list-tile-action>
              <v-icon>language</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t("localization") }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>keyboard_arrow_down</v-icon>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile v-for="lang in defaultLangs" :key="lang.iso" @click="setActiveLanguage(lang.code)">
            <v-list-tile-content>
              <v-list-tile-title>{{ $t(lang.name) }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <img :src="getCountryFlagUrl(lang.iso)" :alt="lang.name" width="24px">
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <v-list-tile v-if="userIsAuthenticated" @click="onLogout">
          <v-list-tile-action>
            <v-icon>power_settings_new</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ $t("logout") }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      app
      dark
      fixed
      dense
      clipped-left
      class="primary elevation-4">
      <v-toolbar-side-icon
        class="hidden-md-and-up"
        @click.stop="sideNav = !sideNav">
      </v-toolbar-side-icon>
      <v-toolbar-title>
        <!-- <router-link to="/" tag="span" style="cursor: pointer"> -->
          <v-list two-line class="pa-0 ma-0" style="background-color:transparent;">
            <v-list-tile>
              <v-list-tile-action>
                <router-link to="/" tag="span" style="cursor: pointer">
                  <img src="static/img/wa_logo.png" class="pa-1 mt-1 mr-2" style="height:44px;"/>
                </router-link>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title class="white--text" style="height:auto;"><router-link to="/" tag="span" style="cursor: pointer"><h3 class="ma-0">{{ $t("app_title")|upper }}</h3></router-link></v-list-tile-title>
                <v-list-tile-sub-title class="white--text"><small><a href="https://www.better-hotel.com" target="_blank" style="text-decoration:none;">BY BETTER-HOTEL.COM</a></small></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        <!-- </router-link> -->
      </v-toolbar-title>

      <v-spacer v-if="userIsAuthenticated"></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="userIsAuthenticated">
        <v-btn
          flat
          to="/search">
          <v-icon right dark class="pr-1">search</v-icon>
          {{ $t("search")|upper }}
        </v-btn>
        <v-btn
          flat
          to="/profile-guests">
          <v-icon right dark class="pr-1">list</v-icon>
          {{ $t("your_records")|upper }}
        </v-btn>
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="userIsAuthenticated">
        <v-btn
          flat
          @click="doShare">
          <v-icon right dark class="pr-1">share</v-icon>
          {{ $t("share")|upper }}
        </v-btn>
        <v-btn
           flat
           @click="about"
           >
          <v-icon right dark class="pr-1">info_outline</v-icon>
          {{ $t("about")|upper }}
        </v-btn>
        <v-btn flat @click.native.stop="showDialog = true">
          <v-btn class="ma-1" color="accent" @click.native.stop="showDialog = true">
            {{ $t("add_guest")|upper }}
          </v-btn>
        </v-btn>
      </v-toolbar-items>
      <v-btn icon @click.native.stop="showDialog = true" class="hidden-md-and-up" v-if="userIsAuthenticated">
        <v-icon>person_add</v-icon>
      </v-btn>

      <v-spacer class="hidden-sm-and-down" v-if="userIsAuthenticated"></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="userIsAuthenticated">
        <v-menu open-on-hover bottom offset-y>
          <v-btn
            flat
            slot="activator"
            >
            {{ hotel_name }}
            <v-icon center dark>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile to="/profile">
              <v-list-tile-title>{{ $t("profile") }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="onLogout">
              <v-list-tile-title>{{ $t("logout") }}</v-list-tile-title>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile v-for="lang in defaultLangs" :key="lang.iso" @click="setActiveLanguage(lang.code)">
              <v-list-tile-content>
                <v-list-tile-title>{{ $t(lang.name) }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <img :src="getCountryFlagUrl(lang.iso)" :alt="lang.name" width="24px">
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down" v-else>
        <v-menu open-on-hover bottom offset-y>
          <v-btn
            flat
            slot="activator"
          >
            <v-icon center dark>home</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile to="/signin">
              <v-list-tile-title>{{ $t("signin") }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile to="/signup">
              <v-list-tile-title>{{ $t("signup") }}</v-list-tile-title>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile @click="about">
              <v-list-tile-title>{{ $t("about") }}</v-list-tile-title>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile v-for="lang in defaultLangs" :key="lang.iso" @click="setActiveLanguage(lang.code)">
              <v-list-tile-content>
                <v-list-tile-title>{{ $t(lang.name) }}</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <img :src="getCountryFlagUrl(lang.iso)" :alt="lang.name" width="24px">
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-content style="background-color:#ecf0f1;">
      <!--<notifications group="app" position="center bottom"/>-->
      <router-view v-title="$t('app_title')"></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import * as utils from './utils'

  export default {
    data () {
      return {
        sideNav: false,
        showDialog: false,

        defaultLangs: [
          {name: 'czech', code: 'cs', iso: 'CZE'},
          {name: 'english', code: 'en', iso: 'GBR'}
        ],
        activeLanguage: ''
      }
    },
    created () {
      this.activeLanguage = this.$ls.get('active_language', 'cs')
    },

    computed: {
      menuItems () {
        let menuItems = [
          {icon: 'lock_open', title: this.$t('signin'), link: '/signin'},
          {icon: 'face', title: this.$t('signup'), link: '/signup'},
          {icon: 'info_outline', title: this.$t('about'), link: ''}
        ]
        if (this.userIsAuthenticated) {
          menuItems = [
            {icon: 'search', title: this.$t('search'), link: '/search'},
            {icon: 'supervisor_account', title: this.$t('your_records'), link: '/profile-guests'},
            {icon: 'person', title: this.$t('profile'), link: '/profile'},
            {icon: 'info_outline', title: this.$t('about'), link: '/'}
          ]
        }
        return menuItems
      },
      userIsAuthenticated () {
        const user = this.$store.getters.user
        // console.log(user)
        return user !== null && user !== undefined && user.uid && user.uid !== null
      },
      hotel_name () {
        const user = this.$store.getters.user
        return user === null || user === undefined ? '' : user.hotel
      },

      user () {
        return this.$store.getters.user
      }
    },

    watch: {
      activeLanguage (val) {
        this.$ls.set('active_language', val)
        // console.log('active_lang: ' + val)
        this.$polyglot.getLocale({ baseURL: 'static/i18n', lang: val })
        this.$polyglot.setLang({ lang: val })
      }
    },

    methods: {
      doShare () {
        this.$swal({
          title: this.$t('share'),
          html: this.$t('share_dlg_text'),
          type: 'question',
          input: 'email',
          showCancelButton: true,
          confirmButtonText: this.$t('share'),
          cancelButtonText: this.$t('cancel')
        }).then(result => {
          if (result.value) {
            utils.HTTP.post('share', { email: result.value })
              .then(response => {
                if (response.data.status > 0) {
                  this.$swal({
                    position: 'bottom-right',
                    type: 'success',
                    title: this.$t('share_done'),
                    showConfirmButton: false,
                    timer: 3000
                  })
                }
              })
              .catch(error => {
                console.log('ERROR Blacklist - sharing: ' + error)
                this.$swal({
                  position: 'bottom-right',
                  type: 'error',
                  title: this.$t('share_error'),
                  showConfirmButton: false,
                  timer: 3000
                })
              })
          }
        })
      },

      about () {
        window.open(this.$t('app_link'), '_blank')
      },

      onLogout () {
        this.$store.dispatch('logout')
        this.$router.push('/')
      },

      setActiveLanguage (code) {
        this.activeLanguage = code
        this.sideNav = false
      },

      getCountryFlagUrl (iso) {
        return utils.getCountryFlagUrl(iso)
      }
    }
  }
</script>

<style lang="stylus">
  @import './stylus/main'
</style>



// WEBPACK FOOTER //
// src/App.vue